import parseBoolean from "./config/parseBoolean"
import "./pt-logic-memory-rs-auto.css"
import { getModelFromInput } from '../../common/getModelFunctions';

export default {
	model: {
		value: {
			default: false
		},
		active: {
			default: false
		}
	},
	computed: {
		input_set() {
			const input = this.$el.dataset.inputs;

			return parseBoolean(getModelFromInput(input, this.$model));
		}
	},
	watch: {
		input_set() {
			const time = parseInt(this.$el.dataset.time || 3);

			if (this.data.input_set) {
				this.data.value = true;
				this.data.active = true;
				setTimeout(() => {
					this.data.active = false;
					this.data.value = false;
				}, time * 1000);
			}
		}
	},
	listeners: {
		click: true
	}
};
